import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StocksService {
  private apiUrl = environment.apiURL + 'campaign-stocks'; // URL del API
  private apiUrlLogs = environment.apiURL + 'campaign-stock-logs'; // URL del API para logs
  constructor(private http: HttpClient) { }


  getStocks(
    pageNumber: number = 1,
    pageSize: number = 1000,
    params: any = {},
    sortColumn: string = 'name',
    sortDirection: string = 'asc'
  ): Observable<any> {

    return this.http.get(this.apiUrl, {
      params: {
        page: pageNumber.toString(),
        pageSize: pageSize.toString(),
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        ...params,
      },
    });
  }

  getStocksGrouped(
    pageNumber: number = 1,
    pageSize: number = 1000,
    params: any = {},
    sortColumn: string = 'name',
    sortDirection: string = 'asc',
    stage: string = ''
  ): Observable<any> {

    return this.http.get(this.apiUrl+'/grouped/' + stage, {
      params: {
        page: pageNumber.toString(),
        pageSize: pageSize.toString(),
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        ...params,
      },
    });
  }
    getStocksStage(
    pageNumber: number = 1,
    pageSize: number = 1000,
    params: any = {},
    sortColumn: string = 'name',
    sortDirection: string = 'asc',
    stage: string = ''
  ): Observable<any> {

    return this.http.get(this.apiUrl+'/campaign-stages/' + stage, {
      params: {
        page: pageNumber.toString(),
        pageSize: pageSize.toString(),
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        ...params,
      },
    });
  }




  addData(item: any): Observable<any> {
    return this.http.post(this.apiUrl + '/new', item);
  }


  addCampaignFromStock(body: any): Observable<any> {
    return this.http.post(this.apiUrl + '/campaign/new' , body);
  }
  // Método para añadir datos a la API
  updateStockData(reference: string, body: any): Observable<any> {
    return this.http.put(this.apiUrl + '/' + reference + '/update', body);
  }

  searchStock(reference: string): Observable<any> {
    return this.http.get(this.apiUrl + '/' + reference);
  }

  addOrderToStock(item: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/order/new`, item);
  }

  getTimeline(item: any): Observable<any> {
    return this.http.get(this.apiUrlLogs + '/timeline/' + item);
  }

  duplicateStock(reference: string): Observable<any> {
    return this.http.get(this.apiUrl + '/' + reference + '/duplicate');
  }

  deleteStock(reference: string): Observable<any> {
    return this.http.delete(this.apiUrl + '/' + reference + '/delete');
  }

}
